import { getRandomInt } from "../utils";

export function keepInView(item, screen) {
  const position = item.point;
  const viewBounds = screen;
  const size = item.size * 2;

  if (position.x > viewBounds.width + 5) {
    position.x = -size;
    position.y = getRandomInt(0, viewBounds.height);
  }

  if (position.x < -size - 5) {
    position.x = viewBounds.width;
    position.y = getRandomInt(0, viewBounds.height);
  }

  if (position.y > viewBounds.height + 5) {
    position.x = getRandomInt(0, viewBounds.width);
    position.y = -size;
  }

  if (position.y < -size - 5) {
    position.x = getRandomInt(0, viewBounds.width);
    position.y = viewBounds.height;
  }
}
